import { IPackageDocumentDTO } from '@/models/documents.model';

interface IDivideRequiredDocs {
  required?: IPackageDocumentDTO[];
  optional?: IPackageDocumentDTO[];
}

export const divideRequiredDocs = (docs: IPackageDocumentDTO[]) =>
  docs?.reduce<IDivideRequiredDocs>(
    (acc, doc) => {
      if (doc.is_required) {
        acc?.required?.push(doc);
      } else {
        acc?.optional?.push(doc);
      }
      return acc;
    },
    { required: [], optional: [] },
  );
